module.exports = __webpack_public_path__ + "static/img/RSUPS108R_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RSUPS108R_1.png
// module id = 4suM
// module chunks = 0